import MuxPlayer from "@mux/mux-player-react/lazy";
const EmbedVideo = ({
  data
}) => {
  const {
    autoPlay = "muted",
    enable,
    mux_video_asset,
    paused = false,
    isFullScreenWidth = true
  } = data;
  const hasVideo = mux_video_asset?.playback_id;
  if (!hasVideo || !enable) return null;
  return <section className={isFullScreenWidth ? "px-4 py-5 md:px-0 md:py-10" : ""} data-sentry-component="EmbedVideo" data-sentry-source-file="EmbedVideo.jsx">
      <div className={isFullScreenWidth ? "bg-videoBg py-5 md:px-4 md:py-8" : ""}>
        <div className="mx-auto md:max-w-screen-xl">
          <MuxPlayer className="accent-video aspect-video max-h-[560px] w-full rounded-3xl object-cover" playbackId={mux_video_asset?.playback_id} autoPlay={autoPlay} muted accent-color="var(--mux-accent-color)" loop paused={paused} style={{
          ...(isFullScreenWidth && {
            "--controls": "none"
          }),
          "--media-object-fit": "cover",
          "--seek-backward-button": "none",
          "--seek-forward-button": "none",
          "--captions-button": "none",
          "--playback-rate-button": "none",
          "--rendition-menu-button": "none"
        }} data-sentry-element="MuxPlayer" data-sentry-source-file="EmbedVideo.jsx" />
        </div>
      </div>
    </section>;
};
export default EmbedVideo;